import React from 'react';
import pulse from '@finn-no/pulse-sdk';
import { Button } from '@fabric-ds/react';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function insertZeroWidthSpace(text) {
  // This function inserts zero width space if slash is in use.
  // This is to try to make stuff break prettier.
  // Previous attempt was using a step thing, e.g. every 10 chars,
  // but this does not make sense imo. Basically these texts should
  // never break though.

  if (!text) {
    return null;
  }
  var softHyphen = '\u200B';
  return text.replace('/', "".concat(softHyphen, "/").concat(softHyphen));
}

var css = {"extendedProfile":"RecommerceExtendedProfileBox-module_extendedProfile__ZDuWg","smallerCollapsedProfile":"RecommerceExtendedProfileBox-module_smallerCollapsedProfile__bhFr5","smallerCollapsedProfileLogoImg":"RecommerceExtendedProfileBox-module_smallerCollapsedProfileLogoImg__jNMYj","extendedProfileLogo":"RecommerceExtendedProfileBox-module_extendedProfileLogo__lcQu5","extendedProfileLogoImg":"RecommerceExtendedProfileBox-module_extendedProfileLogoImg__1-aDb","extendedProfileLogoImgSmall":"RecommerceExtendedProfileBox-module_extendedProfileLogoImgSmall__iiMeI","companyName":"RecommerceExtendedProfileBox-module_companyName__KvpDn","tplink":"RecommerceExtendedProfileBox-module_tplink__zWGFt","tplinkCustomColor":"RecommerceExtendedProfileBox-module_tplinkCustomColor__oHWU2","followers":"RecommerceExtendedProfileBox-module_followers__pEJqT","extendedProfileCTA":"RecommerceExtendedProfileBox-module_extendedProfileCTA__7nfNW"};

var pulseTrackerRecommerce = () => ({
  phonenr: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'Call',
      name: 'Contact seller',
      object: {
        id: 'phone-link',
        type: 'UIElement',
        elementType: 'Phone number'
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Phone',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  sms: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'SMS',
      name: 'Contact seller',
      object: {
        id: 'sms-link',
        type: 'UIElement',
        elementType: 'Phone number'
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Phone',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  moreAdsFrom: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'View',
      name: 'More ads from this organization',
      object: {
        id: 'more-ads-link',
        type: 'UIElement',
        elementType: 'Link'
      },
      target: {
        id,
        type: 'Listing',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  },
  sendMelding: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Send message',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button'
      },
      target: {
        id,
        type: 'Message',
        provider: orgName
      },
      intent: 'Create'
    };
    pulse.trackEvent(pulsePayload);
  },
  cta: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Extended profile action link',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button'
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName
      },
      intent: 'Open'
    };
    pulse.trackEvent(pulsePayload);
  },
  link: (idx, adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      name: 'Extended profile link',
      type: 'Click',
      object: {
        id: 'send-msg-btn',
        type: 'UIElement',
        elementType: 'Button',
        name: "Link: ".concat(idx)
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName
      },
      intent: 'Open'
    };
    pulse.trackEvent(pulsePayload);
  },
  homepage: (adId, orgName) => {
    var id = adId.toString();
    var pulsePayload = {
      type: 'Click',
      intent: 'Open',
      name: 'Homepage link clicked',
      object: {
        id: 'homepage-link',
        type: 'UIElement',
        elementType: 'Link'
      },
      target: {
        id,
        type: 'ExternalContent',
        name: 'Go to webpage',
        provider: orgName
      }
    };
    pulse.trackEvent(pulsePayload);
  }
});

var calcRootStyles = props => ({
  '--extended-profile-text-color': props.textColor,
  '--extended-profile-logo-bgcolor': props.logoBackgroundColor,
  '--extended-profile-cta-text-color': props.ctaColor.textColor,
  '--extended-profile-cta-bgcolor': props.ctaColor.backgroundColor,
  '--extended-profile-cta-bgcolor-hover': props.ctaColor.backgroundHoverColor,
  '--extended-profile-cta-text-color-hover': props.ctaColor.textHoverColor,
  '--extended-profile-cta-bgcolor-active': props.ctaColor.backgroundActiveColor,
  color: props.textColor
});
var renderContact = (contact, adId, orgName, deviceType, tracker, underLineClass, index) => {
  var _contact$phone;
  var phones = (_contact$phone = contact.phone) === null || _contact$phone === void 0 ? void 0 : _contact$phone.map((p, i) => {
    var prefix = p.type !== 'MOBILE' ? 'Telefon ' : 'Mobil ';
    return /*#__PURE__*/React.createElement("a", {
      key: "pnr".concat(i),
      className: "".concat(css.tplink, " ").concat(underLineClass, " text-16 pt-16 pr-8"),
      href: p.phoneAsLink,
      rel: "nofollow",
      onClick: () => {
        tracker.phonenr(adId, orgName);
      }
    }, ' ', prefix.concat(p.phoneFormatted));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-between mr-20 whitespace-nowrap",
    key: "contact_".concat(index)
  }, phones, /*#__PURE__*/React.createElement("a", {
    className: "".concat(css.tplink, " ").concat(underLineClass, " text-16 pt-16 pr-8"),
    href: contact.sendMessageLink,
    onClick: () => {
      tracker.sendMelding(adId, orgName);
    }
  }, "Send melding"));
};
var renderLogo = (logo, isMobileMiniProfile) => /*#__PURE__*/React.createElement("div", {
  className: "flex align-items justify-center border-b rounded-t-8 ".concat(isMobileMiniProfile ? 'pt-8 pb-8 pr-16 pl-16' : 'p-16', " ").concat(css.extendedProfileLogo)
}, /*#__PURE__*/React.createElement("img", {
  className: "".concat(isMobileMiniProfile ? css.smallerCollapsedProfileLogoImg : css.extendedProfileLogoImg, " object-contain object-center"),
  src: logo,
  alt: "Logo"
}));
var renderCta = (contacts, adId, orgName, isMobileMiniProfile, tracker, finnMainSite, cta) => /*#__PURE__*/React.createElement(React.Fragment, null, (cta || contacts && contacts.length > 0) && /*#__PURE__*/React.createElement("div", {
  className: "".concat(isMobileMiniProfile ? '' : 'mt-16')
}, /*#__PURE__*/React.createElement("a", {
  href: cta !== null && cta !== void 0 && cta.url ? cta.url : "".concat(finnMainSite, "contact/").concat(adId, "?ci=0"),
  rel: "nofollow",
  id: css.extendedProfileCTA,
  className: "button button--cta w-full max-w-none",
  onClick: () => {
    tracker.cta(adId, orgName);
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "overflow-hidden whitespace-nowrap",
  style: {
    textOverflow: 'ellipsis'
  }
}, cta !== null && cta !== void 0 && cta.text ? cta.text : 'Send melding'))));
var renderBody = _ref => {
  var {
    orgName,
    contacts,
    suppressMoreAdsFrom,
    moreAdsFromThisCompanyUrl,
    deviceType,
    adId,
    cta,
    customLinks,
    tracker,
    homepageUrl,
    textColor,
    finnMainSite
  } = _ref;
  var basicLinkStyling = textColor === '#000000' ? ' text-blue-600 ' : " underline ".concat(css.tplinkCustomColor);
  var hasLinks = homepageUrl || !suppressMoreAdsFrom || customLinks && customLinks.length > 0;
  var hasBody = hasLinks || cta || contacts && contacts.length > 0;
  if (hasBody) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pb-16"
    }, contacts.map((contact, index) => renderContact(contact, adId, orgName, deviceType, tracker, basicLinkStyling, index)), hasLinks && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mt-16 max-w-max"
    }, homepageUrl && /*#__PURE__*/React.createElement("a", {
      className: "".concat(css.tplink, " ").concat(basicLinkStyling, " text-16 mt-16"),
      href: homepageUrl,
      rel: "nofollow",
      onClick: () => {
        tracker.homepage(adId, orgName);
      }
    }, "Firmaets hjemmeside"), moreAdsFromThisCompanyUrl && /*#__PURE__*/React.createElement("a", {
      className: "".concat(css.tplink, " ").concat(basicLinkStyling, "  text-16 mt-16 max-w-max"),
      href: moreAdsFromThisCompanyUrl,
      rel: "nofollow",
      onClick: () => {
        tracker.moreAdsFrom(adId, orgName);
      }
    }, "Flere annonser"), !suppressMoreAdsFrom && customLinks.map(linkdetails => /*#__PURE__*/React.createElement("a", {
      key: linkdetails.text,
      className: "".concat(css.tplink, " ").concat(basicLinkStyling, " text-16 pt-16 max-w-max"),
      href: linkdetails.url
    }, linkdetails.text))), renderCta(contacts, adId, orgName, false, tracker, finnMainSite, cta));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var mobileCollapsedProfile = (adId, backgroundColor, contacts, cta, isMobileMiniProfile, logo, orgName, tracker, finnMainSite) => /*#__PURE__*/React.createElement("div", {
  className: "".concat(css.smallerCollapsedProfile, " rounded-8"),
  style: {
    backgroundColor: backgroundColor || ''
  }
}, logo && renderLogo(logo, isMobileMiniProfile), (cta || contacts) && /*#__PURE__*/React.createElement("div", {
  className: "px-16 py-16 w-full items-center overflow-hidden"
}, renderCta(contacts, adId, orgName, true, tracker, finnMainSite, cta)));

// eslint-disable-next-line import/prefer-default-export
var RecommerceExtendedProfile = props => {
  var tracker = pulseTrackerRecommerce();
  var {
    logo,
    orgName,
    slogan,
    isSmallerCollapsedProfile,
    cta,
    adId,
    contacts,
    backgroundColor,
    finnMainSite
  } = props;
  var rootStyles = calcRootStyles(props);
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    style: rootStyles,
    className: "".concat(css.extendedProfile, " border rounded-b-8 rounded-t-8")
  }, isSmallerCollapsedProfile ? mobileCollapsedProfile(adId, backgroundColor, contacts, cta, isSmallerCollapsedProfile, logo, orgName, tracker, finnMainSite) : /*#__PURE__*/React.createElement(React.Fragment, null, logo && renderLogo(logo, isSmallerCollapsedProfile), /*#__PURE__*/React.createElement("div", {
    className: "rounded-b-8 ".concat(!logo ? 'rounded-t-8' : ''),
    style: {
      backgroundColor: props.backgroundColor || ''
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-16 pt-16 w-full items-center overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-24"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "".concat(css.companyName, " text-16  mb-8")
  }, insertZeroWidthSpace(orgName)), slogan && /*#__PURE__*/React.createElement("div", {
    className: "text-14"
  }, insertZeroWidthSpace(slogan))), renderBody(_objectSpread2(_objectSpread2({}, props), {}, {
    tracker
  }))))));
};

// eslint-disable-next-line import/prefer-default-export
var Preview = () => /*#__PURE__*/React.createElement("section", {
  "aria-label": "Profil-Preview",
  className: "border rounded-8"
}, /*#__PURE__*/React.createElement("div", {
  className: "px-8 text-center pt-8 w-full"
}, /*#__PURE__*/React.createElement("h4", {
  className: "bg-aqua-50 p-8 mb-6 rounded-8"
}, "Tydelig profil vil vises her n\xE5r annonsen har blitt publisert."), /*#__PURE__*/React.createElement(Button, {
  disabled: true,
  className: "max-w-none mb-8 w-full"
}, "Send melding")));

export { RecommerceExtendedProfile, Preview as RecommercePreview };
//# sourceMappingURL=index.js.map
